export const APP_VERSION = Object.freeze({
  "appName": "Kairo",
  "packageVersion": "0.1.0",
  "gitSha": "93fc824e75f14e4c6de4279195af070e21d442d3",
  "shortGitSha": "93fc824",
  "builtAt": "2026-08-24T12:06:57.761Z",
  "buildId": "0.1.0-93fc824-20260824120657",
  "release": "0.1.0+93fc824"
});
export default APP_VERSION;
